/**
 * Created by andrey on 20.07.17.
 */

const Messages = {
    bundles: [],
    dictionaries: {},
    debugTextCodes: {},

    isInitialized: function () {
        return this.bundles.length > 0 && this.getDictionary(this.bundles[0]) !== undefined;
    },

    getDictionary: function (bundleName) {
        if (this.dictionaries[bundleName]) {
            return this.dictionaries[bundleName];
        }

        const bundle = bundles[bundleName];
        const language = cleverapps.settings.language;

        const resource = bundle.jsons[`dictionary_${language}`] || bundle.urls[`dictionary_${language}`];

        let dictionary;
        if (resource instanceof VirtualJson) {
            dictionary = resource.getJson();
        } else if (resource instanceof VirtualUrl) {
            dictionary = cc.loader.getRes(resource.getUrl());
        }

        if (!dictionary && bundle.jsons.dictionary_en) {
            dictionary = bundle.jsons.dictionary_en.getJson();
        }

        if (dictionary) {
            this.dictionaries[bundleName] = dictionary;
        }

        return dictionary || undefined;
    },

    get: function (code, toReplace) {
        toReplace = toReplace || {};

        if (!code) {
            return "";
        }

        if (!this.isInitialized()) {
            return this.replace(code, toReplace);
        }

        let message = this._findInDictionaries(code);

        let foundInDictionary = true;

        if (!message) {
            if (cleverapps.config.debugMode) {
                console.error(`Non-existent key: ${code}`);
            } else {
                cleverapps.throwAsync(`Non-existent key: ${code}`);
            }

            message = code;

            foundInDictionary = false;
        }

        if (Array.isArray(message)) {
            message = message.map((item) => this.replace(item, toReplace));
        } else {
            message = this.replace(message, toReplace);
        }

        if (cleverapps.config.debugMode && foundInDictionary && typeof message === "string") {
            this.debugTextCodes[message.toLowerCase().replace(/\s/g, ".")] = code;
        }

        return message;
    },

    _findInDictionaries: function (code) {
        for (let i = this.bundles.length - 1; i >= 0; i--) {
            const dictionary = this.getDictionary(this.bundles[i]);

            if (dictionary && dictionary[code] !== undefined) {
                return dictionary[code];
            }
        }
    },

    has: function (code) {
        const value = this._findInDictionaries(code);
        if (!value) {
            return false;
        }

        return value;
    },

    replace: function (message, toReplace) {
        toReplace = toReplace || {};

        if (typeof message === "string") {
            for (const i in toReplace) {
                message = message.split(`%{${i}}`).join(toReplace[i]);
            }
        }
        return message;
    },

    loadLanguage: function (language, callback) {
        if (cleverapps.config.debugMode) {
            this.debugTextCodes = {};
        }

        const toLoad = [];
        const toDelete = [];

        this.bundles.forEach((bundleName) => {
            const bundle = bundles[bundleName];

            cleverapps.config.languages.forEach((other) => {
                const url = bundle.urls[`dictionary_${other}`];
                if (url) {
                    (other === language ? toLoad : toDelete).push(url);
                }
            });
        });

        const waiter = cleverapps.wait(toLoad.length, () => {
            this.dictionaries = {};
            callback();
        });

        toLoad.forEach((url) => cleverapps.bundleLoader.loadLazyResource(url, waiter, waiter));
        toDelete.forEach((url) => cleverapps.bundleLoader.deleteLazyResource(url));
    },

    addBundle: function (bundleName) {
        this.bundles.push(bundleName);
    },

    removeBundle: function (bundleName) {
        const index = this.bundles.indexOf(bundleName);
        if (index !== -1) {
            this.bundles.splice(index, 1);
        }

        delete this.dictionaries[bundleName];
    },

    splitByEmTags: function (text) {
        if (!text || typeof text !== "string") {
            return [];
        }

        const result = [];

        const code = cleverapps.config.debugMode ? this.debugTextCodes[text.toLowerCase().replace(/\s/g, ".")] : undefined;

        const parts = text.split(/(<em>|<\/em>)/);
        let isInsideTag = false;

        for (const part of parts) {
            if (part === "<em>") {
                isInsideTag = true;
                continue;
            }

            if (part === "</em>") {
                isInsideTag = false;
                continue;
            }

            if (part.trim()) {
                result.push({
                    text: part,
                    isEmphasized: isInsideTag,
                    code
                });
            }
        }

        return result;
    }
};

if (cleverapps.config.debugMode) {
    Messages.getLinkToCode = function (code) {
        for (let i = this.bundles.length - 1; i >= 0; i--) {
            const combineMapping = bundles[this.bundles[i]].meta.combineMapping || {};
            const dictionaryMapping = combineMapping.dictionary_en || {};

            const urls = Object.keys(dictionaryMapping);
            for (let j = urls.length - 1; j >= 0; j--) {
                if (dictionaryMapping[urls[j]][code]) {
                    return urls[j].replace(/en\.json$/, `${cleverapps.settings.language}.json`);
                }
            }
        }
    };
}